<template>
  <div class="page-insurance-poster">
    <img :src="poster" class="insurance-poster" />
    <div class="save-button-box">
      <div class="save-button" @click="previewImg">保存至相册或分享好友</div>
    </div>
  </div>
</template>
<script>
import { wxConfig } from "@/plugins/WxConfig.js";
import api from "@/apis/insurance-api.js";
import wx from "weixin-js-sdk";
export default {
  name: "InsurancePoster",
  data() {
    return {
      is_wx: this.browser.wx,
      poster: "https://dummyimage.com/345x640.png/f7eae2/333",
      imageAgent: "https://select-oil-api-new.chedianai.com/image_agent?image="
    };
  },
  mounted() {
    wxConfig(); //H5配置js-sdk
  },
  methods: {
    // 查看图片
    previewImg() {
      console.log(this.poster);
      this.clickPosterSaveTracking();
      if (this.is_wx) {
        wx.previewImage({
          current: "",
          urls: [this.imageAgent+this.poster], // 需要预览的图片 http 链接列表
        });
      } else {
        this.h5Preview([this.imageAgent+this.poster]);
      }
    },
    /**
     * H5查看图片方法
     * @author 田月荣 <tianyuerong@vchangyi.com>
     * @param {array} imgsArr - 预览图片数组
     * @param {number} idx - 当前图片索引
     */
    h5Preview(imgsArr, idx = 0) {
      this.$imagePreview({
        images: imgsArr,
        index: idx,
        defaultOpt: {
          fullscreenEl: false,
          arrowEl: true,
          preloaderEl: true,
          bgOpacity: 0.85,
          preload: [1, 1],
          showHideOpacity: true,
          showAnimationDuration: 0,
        },
      });
    },
    /**
     * 点击海报保存按钮埋点
     */
    async clickPosterSaveTracking() {
      const params = {
        visit_id: this.$route.query.visit_id,
      };
      try {
        const res = await api.clickPosterSaveTrackingApi(params);
        if (res.code !== 0) {
          console.log("点击海报保存按钮埋点异常-response", res);
        }
      } catch (error) {
        console.log("点击海报保存按钮埋点失败-error", error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page-insurance-poster {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  .insurance-poster {
    width: 589/100rem;
    height: 1092/100rem;
    border-radius: 10/100rem;
    margin-top: 26/100rem;
    margin-bottom: 150/100rem;
  }
  .save-button-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 129/100rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
  }
  .save-button {
    width: 582/100rem;
    height: 75/100rem;
    margin-top: 20/100rem;
    border-radius: 99em;
    font-weight: bold;
    color: #000000;
    font-size: 27/100rem;
    line-height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(180deg, #fbd119 0%, #fbc207 100%);
    box-shadow: 0 3/100rem 20/100rem 0 rgba(251, 220, 106, 1);
  }
}
</style>
